module.exports = __webpack_public_path__ + "img/red-square-table-1.700522a1.png";